export function formatDistance(value: number) {
  const numberValue = (value || 0).toLocaleString("hu-HU");
  return `${numberValue} km`;
}
